import { ArrowClockwiseIcon, CloudSlashIcon } from '@phosphor-icons/react'

import { cn } from '@/lib/cn'
import { haptic } from '@/lib/haptics'

/**
 * Estados de carga y error.
 *
 * El esqueleto reserva el espacio exacto que ocupará el contenido: si la
 * pantalla se dibujara vacía y luego creciera, cada carga produciría un salto
 * de layout y el dedo tocaría lo que no era.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-card bg-surface-sunken', className)}
    />
  )
}

/**
 * Un error tiene que decir qué pasó **y** cómo salir de ahí. Un mensaje sin
 * botón de reintento deja al usuario sin más opción que cerrar la app.
 */
export function ErrorState({
  titulo,
  mensaje,
  onReintentar,
}: {
  titulo: string
  mensaje: string
  onReintentar?: () => void
}) {
  return (
    <div className="px-safe mx-auto flex max-w-lg flex-col items-center gap-4 px-6 py-16 text-center">
      <span className="flex size-14 items-center justify-center rounded-full bg-surface-sunken text-ink-faint">
        <CloudSlashIcon size={26} />
      </span>
      <div className="flex flex-col gap-1">
        <p className="font-display text-[18px] font-bold tracking-[-0.02em] text-ink">{titulo}</p>
        <p className="text-[14px] leading-snug text-ink-soft">{mensaje}</p>
      </div>
      {onReintentar ? (
        <button
          type="button"
          onClick={() => {
            haptic('light')
            onReintentar()
          }}
          className="flex min-h-[44px] items-center gap-2 rounded-pill bg-accion px-5 text-[14px] font-semibold text-on-accion active:scale-95"
        >
          <ArrowClockwiseIcon size={16} weight="bold" />
          Reintentar
        </button>
      ) : null}
    </div>
  )
}
